import {
  CommentOutlined,
  HeartOutlined,
  EditOutlined,
  MailOutlined,
  UserOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import { ReactComponent as Gamepad } from '@assets/image/gamepad.svg';

import { Tooltip } from 'antd';

const UserInfoIcon: Record<string, any> = {
  receivedCommentsCount: <CommentOutlined />,
  sentLikesCount: (
    <div style={{ position: 'relative', marginRight: '8px', marginBottom: '2px' }}>
      <UserOutlined />
      <HeartOutlined
        style={{
          position: 'absolute',
          zIndex: 1,
          top: '8px',
          left: '8px',
          background: '#f0f2f5',
        }}
      />
    </div>
  ),
  sentCommentsCount: (
    <div style={{ position: 'relative', marginRight: '8px', marginBottom: '2px' }}>
      <UserOutlined />
      <EditOutlined
        style={{
          position: 'absolute',
          zIndex: 1,
          top: '8px',
          left: '8px',
          background: '#f0f2f5',
        }}
      />
    </div>
  ),
  chatTotalCount: (
    <div style={{ position: 'relative', marginRight: '8px', marginBottom: '2px' }}>
      <MailOutlined />
      <MailOutlined
        style={{
          position: 'absolute',
          zIndex: 1,
          top: '8px',
          left: '8px',
          background: '#f0f2f5',
        }}
      />
    </div>
  ),
  chatCreatedByUserCount: (
    <div style={{ position: 'relative', marginRight: '8px', marginBottom: '2px' }}>
      <UserOutlined />
      <MailOutlined
        style={{
          position: 'absolute',
          zIndex: 1,
          top: '8px',
          left: '8px',
          background: '#f0f2f5',
        }}
      />
    </div>
  ),
  tribes: <TeamOutlined />,
  statuses: <Gamepad/>,
};

const UserTooltip = (title: string, iconName: string) => {
  return (
    <Tooltip
      placement='bottom'
      title={title}
    >
      {UserInfoIcon[iconName]}
    </Tooltip>
  );
};

export default UserTooltip;
